/*
  hh-instagram-link.js
  Points the GSC Instagram Feed widget's follow button at the account that belongs to
  the current domain. The app itself stores one link for all markets, so the theme
  rewrites it. The target URL comes from window.HH_IG_PROFILE_URL (layout/theme.liquid);
  without it this file does nothing.

  Primary path: rewrite the widget config before the app renders it. The app embed
  defines window.GSC_INSTAFEED_WIDGETS in an inline <script> at the end of <head>, and
  the app's renderer (gsc-instafeed-widget.js) is deferred, so this deferred script runs
  between the two. No flash, no DOM rewriting.

  Post permalinks are deliberately left alone: the posts belong to the account that
  published them, so only profile links are switched.
*/
(function () {
  'use strict';

  var TARGET = window.HH_IG_PROFILE_URL;
  if (!TARGET) return;

  var PROFILE = /^https?:\/\/(?:www\.)?instagram\.com\/(?!p\/|reel|tv\/|stories\/|explore\/)[^\/?#]+\/?(?:[?#].*)?$/i;

  function patchWidget(widget) {
    if (!widget || typeof widget !== 'object') return;

    var blocks = widget.blocks;
    if (Array.isArray(blocks)) {
      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        if (block && block.type === 'button' && typeof block.href === 'string' && PROFILE.test(block.href)) {
          block.href = TARGET;
        }
      }
    }

    // Per-locale overrides, keyed "<blockId>.<field>" — e.g. "button-jkKvhUNEZyMa.label".
    var locales = widget.locales;
    if (locales && typeof locales === 'object') {
      Object.keys(locales).forEach(function (locale) {
        var overrides = locales[locale];
        if (!overrides || typeof overrides !== 'object') return;
        Object.keys(overrides).forEach(function (key) {
          if (/\.href$/.test(key) && typeof overrides[key] === 'string' && PROFILE.test(overrides[key])) {
            overrides[key] = TARGET;
          }
        });
      });
    }
  }

  function patchWidgets(list) {
    if (!Array.isArray(list)) return;
    for (var i = 0; i < list.length; i++) patchWidget(list[i]);
  }

  try {
    if (Array.isArray(window.GSC_INSTAFEED_WIDGETS)) {
      patchWidgets(window.GSC_INSTAFEED_WIDGETS);
    } else {
      // App embed hasn't run yet — patch whatever it assigns.
      var pending = window.GSC_INSTAFEED_WIDGETS;
      Object.defineProperty(window, 'GSC_INSTAFEED_WIDGETS', {
        configurable: true,
        get: function () {
          return pending;
        },
        set: function (value) {
          pending = value;
          try {
            patchWidgets(value);
          } catch (e) {}
        }
      });
    }
  } catch (e) {}

  // Fallbacks, in case the app ever renders before this runs.
  function patchRenderedLinks() {
    var links = document.querySelectorAll('.gfa-widget a[href]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.querySelector('img')) continue; // avatar link inside a post popup
      if (PROFILE.test(link.href)) link.href = TARGET;
    }
  }

  patchRenderedLinks();
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', patchRenderedLinks);
    window.addEventListener('load', patchRenderedLinks);
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target && event.target.closest ? event.target.closest('.gfa-widget a[href]') : null;
      if (link && !link.querySelector('img') && PROFILE.test(link.href)) link.href = TARGET;
    },
    true
  );
})();
